import { createSelector } from 'reselect'
import getLoyaltyTransferItems from '../items/getLoyaltyTransferItems'
import calculateDistance from 'lib/geo/distanceBetweenPoints'
import { getAirportsByCode } from 'selectors/flightsSelectors'
import { getCurrentIntl } from 'i18n/util/currentIntl'

const getLoyaltyTransferItemView = createSelector(
  (state: App.State) => getLoyaltyTransferItems(state),
  (state: App.State) => getAirportsByCode(state),
  (state: App.State) => state.destination.googlePlaces,
  (items, airportsByCode, googlePlaces): App.WithDataStatus<Array<App.Checkout.LoyaltyTransferItemView>> => {
    const transfer = items[0]
    const place = googlePlaces[transfer?.pickUpLocation]
    const airport = airportsByCode[transfer?.dropOffLocation]
    if (!transfer || !place || !airport) {
      return {
        hasRequiredData: true,
        data: [],
      }
    }

    const intl = getCurrentIntl()
    return {
      hasRequiredData: true,
      data: [{
        title: intl.formatMessage({
          id: 'MQKDFn2--aBrCuR12mYE',
          defaultMessage: 'Transfer',
          description: 'Title for loyalty transfer item in checkout during checkout',
        }),
        item: transfer,
        loyalty: {},
        dropOffAirport: airport,
        pickUpPlace: place,
        distance: calculateDistance(
          place.latitude,
          place.longitude,
          airport.latitude,
          airport.longitude,
        ),
        totals: {
          price: 0,
          memberPrice: 0,
          value: 0,
          memberValue: 0,
          surcharge: 0,
          extraGuestSurcharge: 0,
          taxesAndFees: 0,
        },
      }],
    }
  },
)

export default getLoyaltyTransferItemView
